import PropTypes from "prop-types"
import { createContext, useContext, useState } from "react"
import { useMutation, useQuery } from "react-query"
import {
  checkAccessCode,
  createClient,
  listClients,
  removeClient,
} from "~/actions/clients"

import AppContext from "./App"

const ClientsContext = createContext()
export default ClientsContext

export const ClientsContainer = ({ children }) => {
  const [clientId, setClientId] = useState(null)
  const createClientMutation = useMutation(createClient)
  const [accessCodeToSend, setAccessCodToSend] = useState([])
  const { authUser } = useContext(AppContext)

  const {
    data: clients,
    refetch: refetchClients,
    isLoading: loadingClients,
  } = useQuery("clients", () => listClients(), { enabled: !!authUser })

  const checkAccessCodeMutation = useMutation((data) => checkAccessCode(data))

  const deleteClientMutation = useMutation(removeClient)

  return (
    <ClientsContext.Provider
      value={{
        createClientMutation,
        refetchClients,
        deleteClientMutation,
        clientId,
        setClientId,
        clients,
        checkAccessCodeMutation,
        accessCodeToSend,
        setAccessCodToSend,
        loadingClients,
      }}
    >
      {children}
    </ClientsContext.Provider>
  )
}

ClientsContainer.propTypes = {
  children: PropTypes.node,
}
